export const ROTATION_ENUM = {
  NORMAL: 0,
  RIGHT: 1,
  LEFT: 2
}
